import { Route, Routes } from "react-router-dom";
import './App.css';
import Header from "./components/Header";
import { Home, Trade } from "./pages";
import { Toaster } from 'react-hot-toast';



function App() {
  return (
    <div>
      <Toaster />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trade" element={<Trade />} />
      </Routes>
    </div>
  );
}

export default App;
